import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'antd'
import { formatMoney, parseMoney } from 'utils/helpers'
import { InputNumber } from 'ui/styled'

const { Item } = Form

const FinancialProgramFields = ({ isInputDisabled = false }) => (
  <>
    <Item name="initial_value" label="Financial Value 1">
      <InputNumber
        min={0}
        max={1000000}
        disabled={isInputDisabled}
        formatter={value => formatMoney(value)}
        parser={value => parseMoney(value)}
        placeholder="0.00"
        data-test="financialInitialValueInput"
      />
    </Item>
    <Item name="final_value" label="Financial Value 2">
      <InputNumber
        min={0}
        max={1000000}
        disabled={isInputDisabled}
        formatter={value => formatMoney(value)}
        parser={value => parseMoney(value)}
        placeholder="0.00"
        data-test="financialFinalValueInput"
      />
    </Item>
  </>
)

FinancialProgramFields.propTypes = {
  isInputDisabled: PropTypes.bool
}

export default FinancialProgramFields
